












import { Vue, Prop, Component } from "vue-property-decorator"

@Component({})
export default class TextBox extends Vue {
	@Prop({ default: false }) background!: boolean;
}
